import { createFileRoute } from "@tanstack/react-router"
import { AppDownload } from "@/components/AppDownload"

export const Route = createFileRoute("/app-qr")({
  head: () => ({
    meta: [
      { title: "Wild Guess App QR Code" },
      {
        name: "description",
        content: "Scan to download Wild Guess Trivia for iPhone or Android.",
      },
    ],
  }),
  component: AppQrPage,
})

function AppQrPage() {
  return <AppDownload autoRedirect={false} showPrintButton />
}
